import React from 'react';
import { LayoutDashboard } from 'lucide-react';
import { PageHeader } from '../components/dashboard/PageHeader';
import { KpiRow } from '../components/dashboard/KpiRow';
import { PrioritasAICallout } from '../components/dashboard/PrioritasAICallout';
import { IssueRadar } from '../components/dashboard/IssueRadar';
import { AlertPanel } from '../components/dashboard/AlertPanel';
import { Recommendations } from '../components/dashboard/Recommendations';
import { IpoleksosbudhankamPanel } from '../components/dashboard/IpoleksosbudhankamPanel';
import { ActorNetworkPanel } from '../components/dashboard/ActorNetworkPanel';
import { MinistryTable } from '../components/dashboard/MinistryTable';
import { NationalThreatLevel } from '../components/dashboard/NationalThreatLevel';
import { PresidentialStabilityIndex } from '../components/dashboard/PresidentialStabilityIndex';
export function ExecutiveDashboard() {
  return <div className="mx-auto flex w-full max-w-[1600px] flex-col gap-6" data-id="element-1780">
      <PageHeader group="Intelijen Presiden" title="Executive Dashboard" description="Ringkasan strategis isu nasional, ancaman siber, dan stabilitas IPOLEKSOSBUDHANKAM secara real-time." icon={LayoutDashboard} data-id="element-1781" />

      {/* ROW A: 5 Strategic KPI Cards */}
      <KpiRow data-id="element-1782" />

      {/* ROW A.5: Threat Level & Stability Index */}
      <div className="grid grid-cols-12 gap-4 sm:gap-6" data-id="element-1783">
        <div className="col-span-12 lg:col-span-7" data-id="element-1784">
          <NationalThreatLevel currentLevel="yellow" data-id="element-1785" />
        </div>
        <div className="col-span-12 lg:col-span-5" data-id="element-1786">
          <PresidentialStabilityIndex data-id="element-1787" />
        </div>
      </div>

      {/* ROW C: Prioritas AI Explainability */}
      <PrioritasAICallout data-id="element-1788" />

      {/* ROW D: Issue Radar (8) + Alerts/Recs (4) */}
      <div className="grid grid-cols-12 gap-4 sm:gap-6" data-id="element-1789">
        <div className="col-span-12 lg:col-span-8 min-h-[450px] lg:h-[450px]" data-id="element-1790">
          <IssueRadar data-id="element-1791" />
        </div>
        <div className="col-span-12 lg:col-span-4 flex flex-col gap-4 sm:gap-6 min-h-[450px] lg:h-[450px]" data-id="element-1792">
          <div className="flex-1 min-h-0" data-id="element-1793">
            <AlertPanel data-id="element-1794" />
          </div>
          <div className="shrink-0" data-id="element-1795">
            <Recommendations data-id="element-1796" />
          </div>
        </div>
      </div>

      {/* ROW E: IPOLEKSOSBUDHANKAM (6) + Actor Network (6) */}
      <div className="grid grid-cols-12 gap-4 sm:gap-6" data-id="element-1797">
        <div className="col-span-12 lg:col-span-6 min-h-[400px] lg:h-[400px]" data-id="element-1798">
          <IpoleksosbudhankamPanel data-id="element-1799" />
        </div>
        <div className="col-span-12 lg:col-span-6 min-h-[400px] lg:h-[400px]" data-id="element-1800">
          <ActorNetworkPanel data-id="element-1801" />
        </div>
      </div>

      {/* ROW F: Ministry Table */}
      <div className="w-full" data-id="element-1802">
        <MinistryTable data-id="element-1803" />
      </div>
    </div>;
}